import { Row, Col, Skeleton, Tooltip, Modal, message } from "antd";
import {  getFormPermissions } from '../../../utils/checkDayPermission';
import axios from "axios";
import classes from "../Pages.module.css";
import { useState, useEffect, useContext } from "react";
import DataContext from "../../../Context/dataContext";
import EmployeeTable from "../EmployeeTable/EmployeeTable";
import { AiFillDelete } from "react-icons/ai";

import { VscFilePdf } from "react-icons/vsc";
import { Link } from "react-router-dom";
import PDFDownloads from "./Outward";

const IssueDetails = (props) => {
  const employeeData = useContext(DataContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState(null);

  const [modalVisible, setModalVisible] = useState(false);
  const [pdfResponse, setPdfResponse] = useState(null);
  const { canAdd, canModify, canDelete, canQuery, messages } = getFormPermissions("Gate Pass Outward", employeeData);
  useEffect(() => {
   
    setRows(null);
    setColumns([]);

    axios
      .get(employeeData.URL + "/api/v1/outwardgatepassdata/inwarddetail", {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);

        setColumns((columns) => {
          let newCols = response.data.data.INWARD.fields.map((col) => {
            return {
              name: col.name,
              title: col.name.split("_").join(" ").toLowerCase(),
            };
          });

          const newNewCols = [
            { name: "D", title: "D" },
            // { name: "V", title: "V" },
            { name: "SNO", title: "SNo" },
            { name: "PDF", title: "PDF" },
            ...newCols,
          ];
          return newNewCols;
        });

        setRows((rows) => {
          let newRows = response.data.data.INWARD.rows.map((row, index) => {
            return {
              D: canDelete ? (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(
                          event,
                          index,
                          response.data.data.INWARD.rows,
                          row["gp_code"]
                        )
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              // V: (
              //   <Tooltip placement="bottom" title="View" color="#1777C4">
              //     <Link
              //       to={
              //         "/sales/transaction/voucher-form-view/" +
              //         row["voucher_code"]
              //       }
              //       style={{ color: "#1777C4", fontWeight: "bolder" }}
              //     >
              //       <RiUserSearchFill
              //         style={{
              //           color: "#1777C4",
              //           fontWeight: "bolder",
              //           fontSize: "0.9rem",
              //         }}
              //       />
              //     </Link>
              //   </Tooltip>
              // ),

              SNO: index + 1,
              PDF: (
                <Tooltip placement="bottom" title="Export" color="#FFA07A">
                  <Link
                    to="#"
                    style={{ color: "FFA07A", fontWeight: "bolder" }}
                  >
                    <VscFilePdf
                      onClick={(event) =>
                        pdfHandler(
                          event,
                          index,
                          response.data.data.INWARD.rows,
                          row["gp_code"]
                        )
                      }
                      style={{
                        color: "#FFA07A",
                        fontWeight: "bolder",
                        fontSize: "1.5rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ),
              ...row,
            };
          });
          return newRows;
        });
      })
      .catch((error) => {
        // // console.log(error);
      });
  }, [employeeData, canDelete, canQuery]);

  const deleteHandler = (event, index, newrows, code) => {
    // // console.log(index);
    // // console.log(index);
    if (!canDelete) {
      message.warning(messages.delete || "You don't have permission to delete items.");
      return;
    }

    setRows(null);
    axios
      .delete(
        employeeData.URL + "/api/v1/outwardgatepassdata/" + code.toString(),
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        // // console.log(response);
        const rowvals = newrows.filter((row) => row["gp_code"] !== code);
        setRows((rows) => {
          let newDRows = rowvals.map((row, index) => {
            return {
              D: canDelete ?(
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(event, index, rowvals, row["gp_code"])
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              // V: (
              //   <Tooltip placement="bottom" title="View" color="#1777C4">
              //     <Link
              //       to={
              //         "/sales/transaction/voucher-form-view/" +
              //         row["voucher_code"]
              //       }
              //       style={{ color: "#1777C4", fontWeight: "bolder" }}
              //     >
              //       <RiUserSearchFill
              //         style={{
              //           color: "#1777C4",
              //           fontWeight: "bolder",
              //           fontSize: "0.9rem",
              //         }}
              //       />
              //     </Link>
              //   </Tooltip>
              // ),

              SNO: index + 1,
              PDF: (
                <Tooltip placement="bottom" title="Export" color="#FFA07A">
                  <Link
                    to="#"
                    style={{ color: "FFA07A", fontWeight: "bolder" }}
                  >
                    <VscFilePdf
                      onClick={(event) =>
                        pdfHandler(
                          event,
                          index,
                          response.data.data.INWARD.rows,
                          row["gp_code"]
                        )
                      }
                      style={{
                        color: "#FFA07A",
                        fontWeight: "bolder",
                        fontSize: "1.5rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ),
              ...row,
            };
          });
          return newDRows;
        });
      })
      .catch((error) => {
        setRows((rows) => {
          let newDRows = newrows.map((row, index) => {
            return {
              D: canDelete ?(
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(event, index, newrows, row["gp_code"])
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              // V: (
              //   <Tooltip placement="bottom" title="View" color="#1777C4">
              //     <Link
              //       to={
              //         "/sales/issuereturnroute/voucher-form-view/" +
              //         row["voucher_code"]
              //       }
              //       style={{ color: "#1777C4", fontWeight: "bolder" }}
              //     >
              //       <RiUserSearchFill
              //         style={{
              //           color: "#1777C4",
              //           fontWeight: "bolder",
              //           fontSize: "0.9rem",
              //         }}
              //       />
              //     </Link>
              //   </Tooltip>
              // ),

              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
        // // console.log(error);
      });
  };

  const pdfHandler = (event, index, newrows, code) => {
    // console.log(index);
    // console.log(index);
    // console.log(index);

    axios
      .get(
        employeeData.URL + "/api/v1/outwardgatepassdata/pdf" + code.toString(),
        {
          withCredentials: true,
          credentials: "include",
        }
      )
      .then((response) => {
        console.log(response);
        setPdfResponse(response.data);
        setModalVisible(true);
        // Assuming you want to navigate to "/pdfDownload" after the axios call
        // window.location.href = "/sales/transaction/pdfDownload";
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  return (
    <>
      <Modal
        title="PDF Download"
        visible={modalVisible}
        onCancel={handleModalCancel}
        footer={null}
        // bodystyle={{ms  }}
        width={1000}
        data={pdfResponse}
      >
        {/* Add your PDF content or an iframe here */}

        {/* Check if pdfResponse is available before rendering the iframe */}

        {pdfResponse && <PDFDownloads pdfResponse={pdfResponse} />}
      </Modal>
      <Row className={classes["Row"]}>
        <Col md={14}>
          <p className={classes["Title"]}>OutWard Gate Pass</p>
        </Col>
        <Col className={classes["Col"]} md={10}></Col>
      </Row>
      <p></p>
      <Row className={classes["Row"]}>
        <Col lg={19} md={17}></Col>
        <Col className={classes["Col"]} lg={5} md={7}>
          <Link to={canAdd ? "/gate/transaction/outwardgatepass":"#"}
          onClick={(e) => !canAdd && e.preventDefault()}
          >
            <button
              disabled={!canAdd}
              style={{
                opacity: canAdd ? 1 : 0.5,
                cursor: canAdd ? 'pointer' : 'not-allowed'
              }}
              className={classes["ProfileButton"]}
            >
              Add Outward
            </button>
          </Link>
        </Col>
      </Row>
      <p></p>
      {rows && columns.length > 0 ? (
        <>
          <EmployeeTable data={rows} columns={columns} val={true} />
        </>
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default IssueDetails;
